module.exports = __webpack_public_path__ + "img/icon-3-aa8e65df.svg";